export default __webpack_public_path__ + "static/media/01-abnormal.e4665f7c.jpg";